export default "__VITE_ASSET__bab14298__"